export default "__VITE_ASSET__CyU$v3xs__"